<template>
  <Dialog
    v-model="show"
    :unlimit-height="true"
    width="750"
    :show-close-button="showCloseButton"
    @close="fecharDialog"
  >
    <template #title>
      <div style="display: flex; align-items: center; justify-content: center; width: 100%;">
        <span style="font-size: 1.2rem; text-transform: uppercase; color: var(--secondary); text-align: center;">
          RESUMO DA PROPOSTA
        </span>
        <ToolTip
          right
          content="O rascunho em questão foi originado do buscador de grupos"
          icon="mdi-help-circle"
          :icon-attrs="{ color: 'primary', size: '18px' }"
          :content-style="{ width: '200px', maxWidth: '200px', fontSize: '12px',  textAlign: 'center' }"
          style="margin-left:8px;"
          color="black"
          nudge-top="40"
        />
      </div>
    </template>

    <v-container>
      <v-row class="d-flex flex-row justify-center align-center">
        <v-col class="text-center">
          <h2 class="font-weight-black" style="font-size: 2.0rem;">Seleções do <br> Buscador:</h2>
          <span class="font-weight-black">Prossiga para gerar uma proposta à seu cliente</span>
        </v-col>
        <v-divider vertical class="secondary mx-2"></v-divider>
        <v-col>
          <p><strong>Código de Simulação:</strong> {{ pedido.cd_simulacao_ed }}</p>
          <p v-if="getDocumento()"><strong>CPF/CNPJ do Cliente:</strong> {{ getDocumento() }} </p>
          <p><strong>Produto:</strong> {{ pedido.nome_produto }}</p>
          <p><strong>Bem:</strong> {{ pedido.nome_bem }}</p>
          <p><strong>Grupo:</strong> {{ pedido.id_grupo }}</p>
          <p><strong>Plano:</strong> {{ pedido.nome_plano }}</p>
          <p><strong>Prazo:</strong> {{ pedido.pz_comercializacao }}</p>
          <p><strong>Parcela:</strong> {{ parcela }}</p>
          <p><strong>Valor do bem:</strong> {{ valorBem }}</p>
          <p><strong>Furo:</strong> {{ OpcoesFuroDesc[pedido.opcao_furo] || '-' }}</p>

          <div class="d-flex justify-end mt-4">
            <v-btn style="font-size: 16px;" class="transition px-8 large" color="primary" rounded @click="confirm">
              OK
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </Dialog>
</template>

<script>
import { OpcoesFuroDesc, TipoPessoa } from '@/plugins/constants'
import { money } from '@/plugins/formatters'

export default {
  name: 'DialogIntegracaoGrupos',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    pedido: {
      type: Object,
      required: true
    },
    showCloseButton: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val) // Atualiza o estado no componente pai
      }
    },
    parcela () {
      let parcela = parseFloat(this.pedido.vl_parcela) || 0

      return money(parcela)
    },
    valorBem () {
      let valor_bem = parseFloat(this.pedido.valor_bem)
      return money(valor_bem)
    },
    OpcoesFuroDesc: () => OpcoesFuroDesc
  },
  methods: {
    getDocumento () {
      if (this.pedido.cliente_simulacao?.pessoa === TipoPessoa.Fisica) {
        return this.pedido.cliente_simulacao.cpf
      }

      if (this.pedido.cliente_simulacao?.pessoa === TipoPessoa.Juridica) {
        return this.pedido.cliente_simulacao.cnpj
      }
    },
    fecharDialog () {
      this.show = false
    },
    confirm () {
      if (this.pedido.cliente_simulacao?.cpf || this.pedido.cliente_simulacao?.cnpj) {
        this.$emit('enviar-dados')
      }

      this.fecharDialog()
    }
  }
}
</script>

<style scoped>
.cabecalho {
  justify-content: flex-end;
  padding: 0 0 12px;
  margin: 12px;
  border-bottom: solid 1px var(--lightgray);

  span {
    width: 100%;
    font-size: 1.2rem;
    text-transform: uppercase;
    color: var(--secondary);
    text-align: center;
  }
}
.description-text {
  text-align: justify;
  font-size: 1rem;
}
.actions {
  text-align: right;
}
.border {
  border: 2px solid red;
}
</style>
